// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"a7b56a2a","787":"21f0e217","965":"669e898f"}[chunkId] + ".chunk.js";
};